export enum OrganizationNames {
  Kells = "kells",
  LibertyDental = "liberty dental",
  KareMobile = "kare mobile",
  Aetna = "aetna",
  Villagecare = "villagecare",
  Teledentists = "teledentists",
  Beanstalk = "beanstalk",
  Lantnerdds = "lantnerdds",
  AYG = "ayg",
  DentalSavers = "dentalsavers",
  OralLink = "orallink",
  UCA = "unified caring association",
  AsiaMedic = "asia medic",
  Benefitsiq = "benefitsiq",
  AYG_dc2c = "ayg d2c",
  Thatch = "thatch",
  Paychex = "paychex",
  Corestream = "corestream",
  Gallagher = "gallagher",
}
